import { lazy } from "react";

const DetailTransaksiComponent = lazy(
	() => import("../../../features/transaction-history/presentation/history-detail")
);
const InvoiceComponent = lazy(
	() => import("../../../features/transaction-history/presentation/invoice")
);
const TransactionRoutes = [
	{
		key: "key.detailtransaction",
		path: "/rinciantransaksi",
		component: DetailTransaksiComponent,
		name: "Detail Transaksi",
	},
	{
		key: "key.detailtransactionafterpayment",
		path: "/rincianpembayaran",
		component: DetailTransaksiComponent,
		name: "Detail Transaksi",
	},
	{
		key: "key.struk",
		path: "/struk",
		component: InvoiceComponent,
		name: "Struk",
	},
];

export default TransactionRoutes;
